import {
  SalesforceItem,
  hasFieldProperties,
  ROLLUP,
} from '../../../../parser/ConfigurationItemTypes';
import { FIELD } from '@server/parser';
import { getChips } from '../../helpers';
import { getItemType } from '../utils';
import { configurationItemTypeToIcon } from '../../latest-deployed/templates/organisms/helpers/icons';
import { ConfigurationTypesWithIcon } from '../../types';
import { isItemActive } from '../../../helpers';
import { TitleWithSubtitle } from '../../../building-blocks/documentation-card/header/TitleWithSubtitle';
import { SfConfigSubtitle } from './SfConfigSubtitle';

interface SfConfigTitleProps {
  configurationItem: SalesforceItem;
  type: string;
  saltoObjectTypes: Pick<ObjectTypeName, 'objectType' | 'label'>[];
}

export const SfConfigTitle = ({
  configurationItem,
  type,
  saltoObjectTypes,
}: SfConfigTitleProps) => {
  const { label, objectApiNames, stagesNames } = configurationItem ?? {};

  const _objectName = objectApiNames?.[0];
  const isField = type === FIELD || type === ROLLUP;
  const fieldConfigurationItem =
    isField && hasFieldProperties(configurationItem) ? configurationItem : undefined;
  const dependencyType = fieldConfigurationItem?.fieldType ?? '';
  const usage = 'usage' in configurationItem ? configurationItem.usage : undefined;
  const { chips, RTchips } = getChips(configurationItem, stagesNames ?? [], saltoObjectTypes ?? []);
  const typeLabel = getItemType({
    saltoObjectTypes: saltoObjectTypes ?? [],
    _objectName,
    parentType: type,
    dependencyType,
  });
  const typeIcon = configurationItemTypeToIcon[type as ConfigurationTypesWithIcon];

  return (
    <TitleWithSubtitle
      label={label}
      subtitle={
        <SfConfigSubtitle
          typeIcon={typeIcon}
          typeLabel={typeLabel}
          chips={chips}
          highlightedChips={RTchips}
          usage={usage}
          showUsage={isField}
          isActive={isItemActive(configurationItem) ? undefined : false}
        />
      }
    />
  );
};
